module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "left-menu"
  }, [_c('LeftMenu')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content-main"
  }, [_c('div', {
    staticClass: "layout-inner-content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('KbAssistant')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32a62396","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/CommonMain.vue
// module id = 1722
// module chunks = 8